
/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/


	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const about = () => `About`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const acceptance = () => `Acceptance`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement = () => `Achievement`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementImageAltText = (params) => `Badge Graphic for ${params.name}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardAnotherCTA = () => `Award another`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardCountSummary = (params) => `${params.count} awarded.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_heading = () => `Badges claimed`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_loginCTA_description = () => `Only members of this community can view claim details. Log in to see claims.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_noneAvailable = () => `No claims are available for this achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCTA = () => `Claim this achievement`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCountSummary = (params) => `${params.count} people have claimed or have been awarded a badge for this achievement, but some claims may not visible if they were not accepted.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewDescription = () => `Bringing an achievement into your space is the first step to recognizing the values and skills that bring your community together.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewHeading = () => `Define a new achievement`




	
/**
 * @param {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_description = (params) => `Delete ${params.name} and ${params.count} member claims? This action cannot be undone.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_heading = () => `Delete achievement and all related claims?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_editCTA = () => `Edit achievement`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_edit_description = () => `When you update an achievement, the new definition will apply to community members who previously claimed it as well as to future awards.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown>, timeAgo: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_invitedByNameAtTime = (params) => `Invited by ${params.givenName} ${params.familyName} ${params.timeAgo}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_name = () => `Achievement name`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_narrative = () => `Achievement narrative`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_openClaimable_description = () => `This achievement may be claimed by anybody.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_other = () => `Achievements`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_share_description = () => `Share this achievement with others who might claim it or learn more about it. For example, you may display or save the QR code to add to a presentation to invite the audience to claim a badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_youHaveClaimed_description = () => `You have successfully claimed a badge for this achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_all = () => `all achievements`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_description = () => `The achievements a community displays shows you what matters in the community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action_other = () => `Actions`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const adminRoleLabel = () => `Admin`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA = () => `Invitation to claim`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA_description = () => `Directly recognize the achievement of a community member with a badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardCTA = () => `Invite`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_createUserIfNotExistsOption = () => `Advanced: Force-create account for this user if they are not yet a member`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_description = () => `You may submit a description of why the member qualifies for this achievement. It will be included in the badge award. If there is a URL that points to evidence of this achievement on the web, you may include that.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_placeholder = () => `They completed a project...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_noneYet = () => `None awarded yet`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_recipientEmail = () => `Recipient email`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge = () => `Awarded badge`




	
/**
 * @param {{ achievementName: NonNullable<unknown>, communityName: NonNullable<unknown>, badgeUrl: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge_email_description = (params) => `Congratulations, you have been awarded a badge for the achievement ${params.achievementName} in the ${params.communityName} community.

You can see your badge here and login to update it:
${params.badgeUrl}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack = () => `Backpack`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyStateCTA = () => `View all achievements`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyState_description = () => `Check out some achievements that are available in this community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadge = () => `Your badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_description = () => `Here are the badges you've earned in this community. Each badge recognizes an achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_heading = () => `Your badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_one = () => `badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_other = () => `badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumb = () => `Breadcrumb`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const cancelCTA = () => `Cancel`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_description = () => `Organize your achievements by category to help your community see what fits together and what is most important.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_editCTA = () => `Edit categories`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_title = () => `Achievement categories`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category = () => `Category`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_achievementCount = () => `Achievement count`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_name = () => `Category name`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_other = () => `Categories`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_weight = () => `Weight`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_cancelFailError = () => `Error storing credential. Operation failed or was canceled by the user. No further details are available.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_description = () => `In order to share your badges between different communities and other sites where you use badges, you may send them to a wallet. This app supports wallets compatible with`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_noPolyfillError = () => `No Credential Handler Polyfill active in this browser.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_walletSignupCTA_description = () => `If you don't yet have a compatible wallet, you can sign up for a new wallet with`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimCTA = () => `Claim`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_adminOnly_description = () => `This achievement may only be awarded by community admins.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_allow = () => `Allow badge claim`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimDisabled = () => `Not claimable`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimEnabled = () => `Claim enabled`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimRequiresSummary = () => `This achievement may be claimed by members who hold a badge for:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_heading = () => `Claim configuration`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_noReviewsRequired_description = () => `Claims are valid immediately and require no review.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_openClaimableCTA = () => `Claim to join the community`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_relatedAchievementNotFoundError = () => `Could not save Achievement settings. The requested related Achievement was not found.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement = () => `Achievement required to claim`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement_description = () => `Select an achievement that a member must already hold in order to be able to claim this badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires = () => `Achievement required to review claims`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires_description = () => `Select an achievement that qualifies a member to be a reviewer for claims for this achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired = () => `Number of reviews required (up to 5)`




	
/**
 * @param {{ reviewsRequired: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequiredSummary = (params) => `Claims require review by ${params.reviewsRequired} members who hold the achievement:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired_description = () => `Enter the number of reviews required before claims become valid. If 0 reviews are required, claims are immediately valid.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_unexpectedSaveError = () => `An unexpected problem saving Achievement configuration occurred.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userMeetsRequirement = () => `You meet this requirement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetRequirement_heading = () => `Not eligible to claim`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetsRequirement = () => `You do not yet hold this prerequisite.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrativeInstructions = () => `Describe your achievement in a few sentences.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_description = () => `You may submit a description of why you qualify for this achievement. It will be included in your badge award. If there is a URL that points to evidence of this achievement on the web, you may include that.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_placeholder = () => `I completed a project..`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_achievementNotClaimableError = () => `This achievement may not be claimed.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeCTA = () => `View or change your claim settings.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeRejectedToAcceptedCTA = () => `Change acceptance: accept badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimBadgeCTA = () => `Claim badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimedByAnonMember = () => `This badge was claimed by a member of the community. See the details of this award below.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_couldNotObtainInvitationError = () => `Could not obtain invitation to claim this badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_editCTA = () => `Edit claim`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationEmailReconciliationError = () => `Invitation could not be reconciled against user emails.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationInvalidError = () => `Invitation invalid.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_noExistingFoundError = () => `No existing claim found.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundError = () => `Badge not found.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundOrNotShareableError = () => `Claim not found or may not be shared.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_rejectCTA = () => `Reject`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_sendToWalletCTA = () => `Send to wallet`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareCTA = () => `Share this badge`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareText_heading = (params) => `I claimed a badge, ${params.name}.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareUrlCopied = () => `Copied sharing URL to clipboard: `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAccepted = () => `Claim accepted.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAcceptedPublic = () => `This badge was accepted by the recipient.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited = () => `You are invited to claim a badge`




	
/**
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvitedFull_description = (params) => `You were invited to claim a badge for this achievement on ${params.createdOn}, but you have not yet accepted it. You may claim it now or reject it. If you would like to add evidence, you may.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited_description = () => `You have been invited to claim a badge for this achievement, but you have not yet accepted the invitation.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected = () => `Badge rejected`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejectedPublic_description = () => `This badge was not accepted by the recipient. Please check with them for more information.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected_description = () => `You have rejected this badge. It will not appear on your profile, and it cannot be downloaded.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUnacceptedPublic = () => `This badge was not yet accepted by the recipient. Please check back soon.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted = () => `You accepted this badge`




	
/**
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted_description = (params) => `You earned this achievement on ${params.createdOn}. It is visible to other members of the community. You can add additional details to your claim. Or you can change your acceptance if you do not want to hold this badge any longer.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidNoReviewRequired = () => `This badge requires no review and is valid.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidSufficientReviews = () => `This badge has received enough reviews and is valid.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedError = () => `This badge may not be claimed by unauthenticated users.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedUserEndorsementError = () => `Unauthenticated users may not endorse this badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_userNotMeetsPrerequsiteError = () => `You do not have the achievement that is a prerequisite for this claim.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validFrom = () => `Valid from`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validUntil = () => `Valid until`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_viewCTA = () => `View badge claim`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveAwarded = (params) => `You've awarded this badge to ${params.givenName} ${params.familyName}.`




	
/**
 * @param {{ inviteeEmail: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveInvited = (params) => `You've successfully created an invitation for ${params.inviteeEmail}. They can join the community and claim a badge for this achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_yourPreferredEmail = () => `Your preferred email`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimed = () => `Claimed`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clipboard_couldNotCopyError = () => `Could not copy to clipboard automatically. Your browser may not support this, or the page may not be served over HTTPS.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const close = () => `Close`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contactCTA = () => `Contact`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contentMissing = () => `Content missing`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const copyCTA = () => `Copy`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const createNewCTA = () => `Create new`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria = () => `Criteria`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_description = () => `Define what must be done to gain this achievement. You may reference an external webpage if needed.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_placeholder = () => `* Show the ability to take initiative by...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_url = () => `Criteria URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date = () => `Date`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const deleteCTA = () => `Delete`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const description = () => `Description`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const downloadCTA = () => `Download`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const earnedBadge = () => `Earned badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const editCTA = () => `Edit`




	
/**
 * @param {{ message: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const email_transmissionError = (params) => `Error sending email: ${params.message}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseFormCTA = () => `Endorse badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_alreadyRecommendedError = () => `You already recommended this person for this achievement. Previous data is shown below.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_description = (params) => `Add your endorsement to ${params.givenName} ${params.familyName}'s badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_narrative_description = () => `You may add your endorsement or review of how this member qualifies for this achievement. It will be included in the badge award. If there is a URL that points to evidence of this achievement on the web, you may include that.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_addYoursCTA = () => `Add yours`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_couldNotIdentifyEmailAddressError = () => `Could not identify an email address. You can make this endorsement via email from the award page.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_other = () => `Endorsements`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_updateCTA = () => `Update your endorsement`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error = () => `Error`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error_unauthorized = () => `Unauthorized`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const evidenceURL = () => `Evidence URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const familyName = () => `Family Name`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const givenName = () => `Given Name`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home = () => `Home`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel = () => `identifier`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel_other = () => `identifiers`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const image = () => `Image`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm = () => `Are you sure you want to reject this badge?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm_description = () => `If you reject this badge, it will not be shown on your profile or be verifiable. You can change your mind in the future.`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteJoinCTA_description = (params) => `You've been invited to claim a badge and join the ${params.name} community. Confirm your email address to continue.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_achievementUnauthorizedError = () => `You may not award this achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_notFoundError = () => `Unknown invitation. This invitation not exist or may no longer be valid.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_recipientIdentifierRequiredError = () => `Recipient identifier is required.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_unauthorizedNonAdminError = () => `You may not invite others to claim this achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const linkedin_addToProfileButton_label = () => `LinkedIn Add to Profile button`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logInCTA = () => `Log in`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logOutCTA = () => `Log out`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginCTA_description = () => `If you are a registered user, you can sign in to manage skills in this community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA = () => `Log in to accept invite`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA_description = () => `You've been invited to earn a badge and join the community. Complete your registration to continue.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_agreeTermsError = () => `You must agree to the terms to join the community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_checkEmailCTA_description = () => `Check your email for your verification code.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailNotParsedError = () => `You must enter a valid email address to log in.`




	
/**
 * @param {{ code: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailVerificationCodeIs = (params) => `Your verification code is: ${params.code}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_incorrectCodeError = () => `Incorrect code.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_invitationRequiredError = () => `Cannot sign in with this email address without an invitation. Check your email for an invitation link.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_sendCodeCTA = () => `Send code`




	
/**
 * @param {{ orgName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_toCommunityNameCTA = (params) => `Log into ${params.orgName}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_verificationCodeRequiredError = () => `Verification code is required.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const markdown_description = () => `You may enter text formatting with Markdown.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const me = () => `me`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const media_localMediaOnlyAvailableInDevError = () => `Local media is only avaialable for development environments.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member = () => `Member`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_memberDetailsLabel = () => `Member details`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_notFoundError = () => `Member not found with this id.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_other = () => `Members`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_otherUserProfileDescription = () => `A user associated with this community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_settingsChangeUnauthenticedError = () => `Only authenticated users can change settings.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_share_description = () => `You can share a URL to your profile, where other people can see the badges you've earned. It will only by visible to other members of the community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_yourProfileGreeting = () => `This is your profile.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_description = () => `Users associated with this community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_title = () => `Community Members`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const membership = () => `Membership`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const mostAwardedAchievements = () => `Most awarded achievements`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const narrative = () => `Narrative`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const notFound = () => `Not found`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_editCTA = () => `Edit organization`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_edit_description = () => `As an organization admin, you may update descriptive information about the org.`




	
/**
 * @param {{ orgName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin = (params) => `Invitation to join ${params.orgName}`




	
/**
 * @param {{ achievementName: NonNullable<unknown>, orgName: NonNullable<unknown>, inviteLink: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin_description = (params) => `You've been invited to claim a badge for the achievement ${params.achievementName}

By claiming a badge, you can join the ${params.orgName} community. Click here to join:

${params.inviteLink}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_name = () => `Organization name`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_primaryColor = () => `Primary color`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_url = () => `Community homepage:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_usesOrca = () => `This community is using ORCA to recognize skills and achievements.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organization_notFoundError = () => `ORCA community not found.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const otherUserBadge_heading = (params) => `${params.givenName} ${params.familyName}'s badge`




	
/**
 * @param {{ page: NonNullable<unknown>, maxPage: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const paginationSummary = (params) => `Page ${params.page} of ${params.maxPage} (${params.count} total results)`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const previewCTA = () => `Preview`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const privacyPolicy = () => `Privacy policy`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile = () => `Profile`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile_editCTA = () => `Edit settings`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const qrCode = () => `QR code`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_genericError = () => `Could not register. Try to log in again.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const requirement_statusInvalid = () => `Invalid requirement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const saveCTA = () => `Save`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const seeCTA = () => `See`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const session_invalidError = () => `Invalid session.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const setting_other = () => `Settings`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share = () => `Share`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_copyUrl = () => `Copy URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_description = () => `You can copy the public URL for your badge to share via social media, import into other badge backpacks, send in emails, or include on your CV.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_description = () => `Display this QR code or save it to your device to share your badge with others, such as inviting somebody to endorse you.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_heading = () => `Share by QR code`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCodeImageAltText = () => `A QR Code image that may be scanned with a phone or scanner`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status = () => `Status`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_accepted = () => `Accepted`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_created = () => `Created`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited = () => `Invited`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_description = () => `You have been invited to claim this badge, but you have not accepted.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_medium = () => `Invited to claim a badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_loading = () => `Loading...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed = () => `This badge is still under review.`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed_description = (params) => `Not yet reviewed. This badge is valid once it accumulates ${params.count} endorsements by holders of:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_prerequisiteRequired = () => `Prerequisite required`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected = () => `Rejected`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected_description = () => `You were invited to claim this badge, but you have rejected this claim. No other members of the community will see that you have the achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_underReview = () => `Under Review`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_valid = () => `Valid`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_verified = () => `verified`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const submitCTA = () => `Submit`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tagline = () => `Have a skillful day.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const termsOfService = () => `Terms of service`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const themeCTA_description = () => `Toggle interface between light and dark mode.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tos_agreementCTA_description = () => `I agree to the Terms of Service and Privacy Policy for this community`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const unauthenticatedError = () => `Unauthenticated`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const uncategorized = () => `Uncategorized`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const url = () => `URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const verificationCode = () => `Verification code`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view = () => `View`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const writeCTA = () => `Write`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const yourEmail = () => `Your email`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const removeCTA = () => `Remove`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const changeCta = () => `Change`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_selectThisCTA = () => `Select this achievement`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_searchByName = () => `Search Achievements by name`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound = () => `No achievements found.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound_description = () => `This community does not have any visible achievements.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorLoading = () => `Error loading achievements`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requireAReview = () => `Require a review before awards are valid`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_chooseCTA = () => `Choose achievement`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_anAdminReviewRequired = () => `Claims must be reviewed by an admin.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteRequires_notFound = () => `Achievement required to invite not found.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiredCrossValidationMessage = () => `A badge must be selected if review by a holder is required.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardByInvitation = () => `Not claimable. Award by invitation only.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabel = () => `Is a review required?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabelSpecific = () => `Reviewed by holders of a specific badge: `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiresLabel = () => `Who may invite people to claim a badge?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requirementHoldersOf = () => `Holders of a specific badge: `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chooseCTA = () => `Choose...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_errorFetchingData = () => `Error fetching backpack data!`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorFetchingData = () => `Error fetching achievements!`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_claimRequiresCrossValidationMessage = () => `An achievement must be selected if claim requires it.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteREquiresCrossValidationMessage = () => `A badge must be selected if review by invite is required.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiredGeneric = () => `This achievement is only awardable by invitation.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_inviteRequiresDescription = () => `Invitations to claim may be made by holders of:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const authentication_couldNotLogIn = () => `Could not log in.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bad_bold_shrimp_express = () => `Date`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tense_raw_cuckoo_dart = () => `You may not invite others to claim this achievement, because your qualifying badge is not yet valid.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const known_such_scallop_gaze = () => `Reject`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const proof_funny_dog_pat = () => `Accept`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sunny_grand_lemur_race = () => `Invalid email address`




	
/**
 * @param {{ achievementName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const dull_bright_ostrich_delight = (params) => `${params.achievementName} badge image`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const merry_trite_seahorse_relish = () => `You hold a badge for this achievement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gray_fluffy_myna_pet = () => `Reviewed by an admin`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const aqua_alive_cougar_tickle = () => `Only admins`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home_vivid_mole_gaze = () => `You can control how your profile is displayed to other users in the community and how your credentials are delivered to you.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const nice_active_giraffe_propel = () => `Identifier`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const warm_male_thrush_pout = () => `Type`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clear_crazy_meerkat_nurture = () => `Visibility`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const short_deft_lemur_clasp = () => `Public`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const equal_small_dolphin_spur = () => `Community members only`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pink_last_marten_grin = () => `Private (admins only)`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const best_sweet_termite_work = () => `Who can see the badges you've earned by default? You can choose to override this for each individual badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const direct_plane_boar_succeed = () => `Default badge visibility`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const every_flat_lamb_favor = () => `Choose...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const fancy_antsy_ray_gaze = () => `No`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tired_top_fish_bask = () => `Claimable by holders of a specific badge: `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const factual_agent_mantis_jump = () => `Unknown error`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const elegant_free_cow_cherish = () => `What makes this community special is...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const grand_tangy_cheetah_buy = () => `Tagline`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const moving_east_okapi_shrine = () => `Celebrate your skills in community.`

